import { defineComponent as _defineComponent } from 'vue'
import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, resolveComponent as _resolveComponent, createBlock as _createBlock, withCtx as _withCtx, createVNode as _createVNode, createTextVNode as _createTextVNode, unref as _unref, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, resolveDirective as _resolveDirective, withDirectives as _withDirectives, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-4882ed9f"),n=n(),_popScopeId(),n)
const _hoisted_1 = /*#__PURE__*/_createTextVNode("搜索")
const _hoisted_2 = /*#__PURE__*/_createTextVNode("重置")
const _hoisted_3 = /*#__PURE__*/_createTextVNode("导入")
const _hoisted_4 = /*#__PURE__*/_createTextVNode("导出")
const _hoisted_5 = /*#__PURE__*/_createTextVNode("月度效率值管理模版下载")
const _hoisted_6 = {
  key: 0,
  class: "d-flex align-items-center justify-content-center"
}
const _hoisted_7 = {
  key: 1,
  style: {"width":"100%"},
  class: "d-flex align-items-center justify-content-center"
}
const _hoisted_8 = { style: {"width":"150px"} }
const _hoisted_9 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", null, "译员薪酬成本", -1))
const _hoisted_10 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", null, "(应发合计+五险一金公司部分)", -1))
const _hoisted_11 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", null, "效率值", -1))
const _hoisted_12 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", null, "(薪酬/字数)", -1))
const _hoisted_13 = /*#__PURE__*/_createTextVNode("选择文件")
const _hoisted_14 = /*#__PURE__*/_createTextVNode("取消")
const _hoisted_15 = /*#__PURE__*/_createTextVNode("确定")

import {ref, onActivated, reactive, onMounted} from 'vue';
import {Upload } from '@element-plus/icons-vue'
import dayjs from "dayjs"
import {exportHandle} from '@/utils/index'
import {
  Check, Close
} from '@element-plus/icons-vue'
import Api from '@/http/modules/index'
import { ElMessage } from 'element-plus';

export default /*#__PURE__*/_defineComponent({
  props: {
    translatorList:{
        default:[]
    },
    orgList:{
        default:[]
    }
},
  setup(__props) {

const props = __props

let {
    // 译员列表
    'GET/efficiency/translator/users':translatorListApi,
    // 月度效率值管理查询
    'POST/efficiency/translator/manage':effListApi,
    // 修改翻译字数
    'POST/efficiency/translator/update':efficiencyUpdateApi,
    // 导出
    'POST/efficiency/translator/manage/export':efficiencyExportApi,
    // 月度效率值管理导入模版下载
    'POST/efficiency/translator/manage/import/template':efficiencyTemplateApi,
    
    // 月度效率值管理导入
    'POST/efficiency/translator/manage/import':efficiencyImportApi,   
}=Api
const tableHeight=window.innerHeight-200

let defaultMonth=dayjs(new Date().setMonth(new Date().getMonth()-1)).startOf("month").format("YYYY-MM-DD")
const queryForm=ref<any>({
    month:defaultMonth
})
const effLists=ref([])
const listLoading=ref(false)
const average=ref<any>({})
const getEffList=(isReset:boolean=false)=>{
    if(isReset){
        queryForm.value={month:defaultMonth}
        queryForm.value.showLeave=false
    }
    let {userIds,month,orgIds,showLeave}=queryForm.value
    let params={
        userIds:userIds||[],
        orgIds:orgIds||[],
        month:month?dayjs(month).format('YYYY-MM-DD'):'',
        showLeave:showLeave||false
    }
    listLoading.value=true
    effListApi(params).then((res:any)=>{
        effLists.value=res.data
        average.value=res.sum
        listLoading.value=false
    }).catch(()=>{
        listLoading.value=false
    })
}
const editHandle=(prop:string,row:any)=>{
        row.monthTranslateEdit=true
        row.monthTranslateEditValue=row[prop]
}
const cancelEdit=(prop:string,row:any)=>{
        row.monthTranslateEdit=false
}
const saveEdit=(prop:string,value:any,row:any)=>{
    row[prop]=value
    let {userId,monthTranslate,overtimeTranslate}=row
    let params={
        userId,monthTranslate,overtimeTranslate,
        month:dayjs(queryForm.value.month).format('YYYY-MM-DD')
    }
    efficiencyUpdateApi(params).then((res:any)=>{
        getEffList()
    })
}
const exportLoading=ref(false)
const exportEff=async ()=>{
    let params={
        userIds:queryForm.value.userIds||[],
        month:dayjs(queryForm.value.month).format('YYYY-MM-DD'),
    }
    exportLoading.value=true
    await exportHandle(efficiencyExportApi,params)
    exportLoading.value=false
}
const getSummaries=(param:any)=>{
   const { columns, data } = param;
      let sums:any = [];
      columns.forEach((column:any, index:any) => {
        if (index === 1) {
          sums[index] = "合计";
          return;
        } else if (column.property != "realName"&&column.property != "alias") {
            switch(column.property){
                case 'monthTranslate':
                   sums[index] =average.value.monthTranslate
                   break;
                
                case 'overtimeTranslate':
                    sums[index] =average.value.overtimeTranslate
                   break;
                case 'actualTranslate':
                    sums[index] =average.value.actualTranslate
                   break;

                case 'commission':
                    sums[index] =average.value.commission
                   break;
                case 'totalSalary':
                    sums[index] =average.value.totalSalary
                   break;
                case 'efficiency':
                    sums[index] =average.value.efficiency
                   break;
                
            }
        }
      });
      return sums;
}
// 模板下载
const downLoading=ref(false)
const downLoadHandle=async ()=>{
    downLoading.value=true
    await exportHandle(efficiencyTemplateApi,{})
    downLoading.value=false
}
// 批量导入
const efficiencyDialogVisible=ref(false)
const importTime=ref("")
let fileList = ref<any>([])
const upload=ref()
const handleExceed = (files: any) => {
    upload.value.clearFiles()
    upload.value.handleStart(files[0])
}
const onFileChange = (file: any, files: any) => {
  fileList.value = files
}
const importLoading=ref(false)
const importHandle=()=>{
    if(!importTime.value){
        ElMessage.warning("请选择时间")
        return
    }
    if(!fileList.value.length){
        ElMessage.warning("请选择文件")
        return
    }
    let formData=new FormData()
    importLoading.value=true
    formData.append('month',dayjs(importTime.value).format("YYYY-MM-DD"))   
    formData.append('file',fileList.value[0].raw)
    efficiencyImportApi(formData).then((res:any)=>{
        ElMessage.success('导入成功')
        importLoading.value=false
        efficiencyDialogVisible.value=false
        getEffList()
    }).catch(()=>{
        importLoading.value=false
    }) 
}
const closeHandle=()=>{
    importTime.value=""
    upload.value.clearFiles()
    fileList.value=[]
}
onMounted(()=>{
    getEffList()
})

return (_ctx: any,_cache: any) => {
  const _component_el_option = _resolveComponent("el-option")!
  const _component_el_select = _resolveComponent("el-select")!
  const _component_el_form_item = _resolveComponent("el-form-item")!
  const _component_el_date_picker = _resolveComponent("el-date-picker")!
  const _component_el_checkbox = _resolveComponent("el-checkbox")!
  const _component_el_button = _resolveComponent("el-button")!
  const _component_el_form = _resolveComponent("el-form")!
  const _component_el_collapse_item = _resolveComponent("el-collapse-item")!
  const _component_el_collapse = _resolveComponent("el-collapse")!
  const _component_el_table_column = _resolveComponent("el-table-column")!
  const _component_el_input_number = _resolveComponent("el-input-number")!
  const _component_Edit = _resolveComponent("Edit")!
  const _component_el_icon = _resolveComponent("el-icon")!
  const _component_el_table = _resolveComponent("el-table")!
  const _component_el_upload = _resolveComponent("el-upload")!
  const _component_el_dialog = _resolveComponent("el-dialog")!
  const _directive_loading = _resolveDirective("loading")!

  return (_openBlock(), _createElementBlock("div", null, [
    _createVNode(_component_el_collapse, null, {
      default: _withCtx(() => [
        _createVNode(_component_el_collapse_item, { title: "搜索" }, {
          default: _withCtx(() => [
            _createVNode(_component_el_form, {
              class: "searchBg",
              style: {"padding-top":"26px"},
              inline: true,
              model: queryForm.value,
              "label-width": "50px",
              "label-position": "left"
            }, {
              default: _withCtx(() => [
                _createVNode(_component_el_form_item, {
                  label: "姓名:",
                  prop: "name"
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_el_select, {
                      style: {"width":"260px"},
                      "collapse-tags": "",
                      "collapse-tags-tooltip": "",
                      modelValue: queryForm.value.userIds,
                      "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((queryForm.value.userIds) = $event)),
                      filterable: "",
                      multiple: "",
                      clearable: ""
                    }, {
                      default: _withCtx(() => [
                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(props.translatorList, (item) => {
                          return (_openBlock(), _createBlock(_component_el_option, {
                            key: item.id,
                            label: item.realName+`(${item.alias})`,
                            value: item.userId
                          }, null, 8, ["label", "value"]))
                        }), 128))
                      ]),
                      _: 1
                    }, 8, ["modelValue"])
                  ]),
                  _: 1
                }),
                _createVNode(_component_el_form_item, {
                  label: "团队:",
                  prop: "orgIds"
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_el_select, {
                      style: {"width":"260px"},
                      "collapse-tags": "",
                      "collapse-tags-tooltip": "",
                      modelValue: queryForm.value.orgIds,
                      "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((queryForm.value.orgIds) = $event)),
                      filterable: "",
                      multiple: "",
                      clearable: ""
                    }, {
                      default: _withCtx(() => [
                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(props.orgList, (item) => {
                          return (_openBlock(), _createBlock(_component_el_option, {
                            key: item.id,
                            label: item.name,
                            value: item.id
                          }, null, 8, ["label", "value"]))
                        }), 128))
                      ]),
                      _: 1
                    }, 8, ["modelValue"])
                  ]),
                  _: 1
                }),
                _createVNode(_component_el_form_item, {
                  label: "日期:",
                  prop: "month"
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_el_date_picker, {
                      type: "month",
                      modelValue: queryForm.value.month,
                      "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((queryForm.value.month) = $event)),
                      clearable: false
                    }, null, 8, ["modelValue"])
                  ]),
                  _: 1
                }),
                _createVNode(_component_el_form_item, {
                  label: "显示已离职用户:",
                  prop: "showLeave",
                  "label-width": "115"
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_el_checkbox, {
                      onChange: _cache[3] || (_cache[3] = ()=>getEffList()),
                      modelValue: queryForm.value.showLeave,
                      "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((queryForm.value.showLeave) = $event)),
                      label: ""
                    }, null, 8, ["modelValue"])
                  ]),
                  _: 1
                }),
                _createVNode(_component_el_form_item, null, {
                  default: _withCtx(() => [
                    _createVNode(_component_el_button, {
                      type: "primary",
                      onClick: _cache[5] || (_cache[5] = ($event: any) => (getEffList()))
                    }, {
                      default: _withCtx(() => [
                        _hoisted_1
                      ]),
                      _: 1
                    }),
                    _createVNode(_component_el_button, {
                      onClick: _cache[6] || (_cache[6] = ($event: any) => (getEffList(true)))
                    }, {
                      default: _withCtx(() => [
                        _hoisted_2
                      ]),
                      _: 1
                    })
                  ]),
                  _: 1
                })
              ]),
              _: 1
            }, 8, ["model"])
          ]),
          _: 1
        })
      ]),
      _: 1
    }),
    _createVNode(_component_el_button, {
      loading: exportLoading.value,
      class: "mt-10",
      type: "primary",
      onClick: _cache[7] || (_cache[7] = ($event: any) => (efficiencyDialogVisible.value=true))
    }, {
      default: _withCtx(() => [
        _hoisted_3
      ]),
      _: 1
    }, 8, ["loading"]),
    _createVNode(_component_el_button, {
      loading: exportLoading.value,
      class: "mt-10",
      onClick: exportEff
    }, {
      default: _withCtx(() => [
        _hoisted_4
      ]),
      _: 1
    }, 8, ["loading"]),
    _createVNode(_component_el_button, {
      loading: downLoading.value,
      class: "mt-10",
      onClick: downLoadHandle
    }, {
      default: _withCtx(() => [
        _hoisted_5
      ]),
      _: 1
    }, 8, ["loading"]),
    _withDirectives((_openBlock(), _createBlock(_component_el_table, {
      "summary-method": getSummaries,
      "show-summary": "",
      border: "",
      "max-height": tableHeight+'px',
      data: effLists.value,
      class: "mt-10"
    }, {
      default: _withCtx(() => [
        _createVNode(_component_el_table_column, {
          label: "中文名",
          prop: "realName"
        }),
        _createVNode(_component_el_table_column, {
          label: "英文名",
          prop: "alias"
        }),
        _createVNode(_component_el_table_column, {
          label: "团队",
          prop: "orgName"
        }),
        _createVNode(_component_el_table_column, {
          label: "月度翻译总字数",
          prop: "monthTranslate",
          align: "center",
          width: "200"
        }, {
          default: _withCtx(({row}) => [
            (row.monthTranslateEdit)
              ? (_openBlock(), _createElementBlock("div", _hoisted_6, [
                  _createVNode(_component_el_input_number, {
                    size: "small",
                    style: {"width":"100px"},
                    modelValue: row.monthTranslateEditValue,
                    "onUpdate:modelValue": ($event: any) => ((row.monthTranslateEditValue) = $event),
                    min: 0,
                    controls: false
                  }, null, 8, ["modelValue", "onUpdate:modelValue"]),
                  _createVNode(_component_el_button, {
                    onClick: ($event: any) => (saveEdit('monthTranslate',row.monthTranslateEditValue,row)),
                    style: {"margin-left":"5px"},
                    size: "small",
                    icon: _unref(Check),
                    circle: ""
                  }, null, 8, ["onClick", "icon"]),
                  _createVNode(_component_el_button, {
                    onClick: ($event: any) => (cancelEdit('monthTranslate',row)),
                    style: {"margin-left":"5px"},
                    size: "small",
                    icon: _unref(Close),
                    circle: ""
                  }, null, 8, ["onClick", "icon"])
                ]))
              : (_openBlock(), _createElementBlock("div", _hoisted_7, [
                  _createElementVNode("span", _hoisted_8, _toDisplayString(row.monthTranslate), 1),
                  _createVNode(_component_el_icon, {
                    onClick: ($event: any) => (editHandle('monthTranslate',row)),
                    class: "editIcon"
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_Edit)
                    ]),
                    _: 2
                  }, 1032, ["onClick"])
                ]))
          ]),
          _: 1
        }),
        _createVNode(_component_el_table_column, {
          label: "译员提成",
          prop: "commission",
          align: "right"
        }),
        _createVNode(_component_el_table_column, {
          prop: "totalSalary",
          align: "center",
          width: "250"
        }, {
          header: _withCtx(() => [
            _hoisted_9,
            _hoisted_10
          ]),
          _: 1
        }),
        _createVNode(_component_el_table_column, {
          label: "效率值",
          prop: "efficiency",
          align: "center"
        }, {
          header: _withCtx(() => [
            _hoisted_11,
            _hoisted_12
          ]),
          _: 1
        })
      ]),
      _: 1
    }, 8, ["max-height", "data"])), [
      [_directive_loading, listLoading.value]
    ]),
    _createVNode(_component_el_dialog, {
      modelValue: efficiencyDialogVisible.value,
      "onUpdate:modelValue": _cache[10] || (_cache[10] = ($event: any) => ((efficiencyDialogVisible).value = $event)),
      title: "导入译员效率值",
      width: "500",
      onClose: closeHandle
    }, {
      footer: _withCtx(() => [
        _createVNode(_component_el_button, {
          onClick: _cache[9] || (_cache[9] = ($event: any) => (efficiencyDialogVisible.value=false))
        }, {
          default: _withCtx(() => [
            _hoisted_14
          ]),
          _: 1
        }),
        _createVNode(_component_el_button, {
          type: "primary",
          loading: importLoading.value,
          onClick: importHandle
        }, {
          default: _withCtx(() => [
            _hoisted_15
          ]),
          _: 1
        }, 8, ["loading"])
      ]),
      default: _withCtx(() => [
        _createVNode(_component_el_date_picker, {
          modelValue: importTime.value,
          "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event: any) => ((importTime).value = $event)),
          type: "month",
          placeholder: "请选择时间"
        }, null, 8, ["modelValue"]),
        _createVNode(_component_el_upload, {
          ref_key: "upload",
          ref: upload,
          limit: 1,
          "auto-upload": false,
          "on-exceed": handleExceed,
          "on-change": onFileChange,
          class: "mt-10"
        }, {
          default: _withCtx(() => [
            _createVNode(_component_el_button, null, {
              default: _withCtx(() => [
                _hoisted_13,
                _createVNode(_component_el_icon, { class: "el-icon--right" }, {
                  default: _withCtx(() => [
                    _createVNode(_unref(Upload))
                  ]),
                  _: 1
                })
              ]),
              _: 1
            })
          ]),
          _: 1
        }, 512)
      ]),
      _: 1
    }, 8, ["modelValue"])
  ]))
}
}

})